<template lang="pug">
  .froala
    froala(
      :tag="'textarea'"
      :config="config"
      v-model="model"
      v-if="is_edit")
    froalaView(
      v-model="model"
      v-else)
</template>

<script>
  // @vue/component

  import liquid_variables from '../organisms/rich_text_editor/liquid_variables'
  import Froala from 'vue-froala-wysiwyg'

  function generate_menu(liquid_variables) {
    let menu = []
    liquid_variables.forEach((category) => {
      menu.push(
        `<ul class="fr-dropdown-list" role="presentation">
          <li role="presentation">
            <a>
              <span>${ category.name }</span>
              <i class="fa fa-chevron-right"></i>
            </a>
            <ul style="list-style: none;">
              ${ generate_sub_menu(category.sub_menu) }
            </ul>
          </li>
        </ul>`
      )
    })
    return menu.join('')
  }

  function generate_sub_menu(sub_menu_variables) {
    let sub_menu = []
    sub_menu_variables.forEach((variable) => {
      sub_menu.push(
        `<li role="presentation">
          <a class="fr-command" role="option" data-cmd="liquid_variables" data-param1="${ variable.content }">
            <span>${ variable.name }</span>
          </a>
        </li>`
      )
    })
    return sub_menu.join('')
  }

  // @vue/component
  export default {
    name: 'froala_editor',
    props: {
      rich_text: {
        type: String,
        default: 'Insert Text'
      },
      is_edit: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        model: this.rich_text,
        config: {
          events: {
            toolbarButtons: (() => {
              // $.FroalaEditor.DefineIcon('liquid_variables', {NAME: 'cog', FA5NAME: 'cog'});
              // $.FroalaEditor.RegisterCommand('liquid_variables', {
              //   title: 'Insert Variables',
              //   type: 'dropdown',
              //   focus: false,
              //   undo: false,
              //   html: generate_menu(liquid_variables),
              //   callback: (cmd, val) => {
              //     console.log(this)
              //   }
              // });
              //
              // let toolbar_buttons = $.FroalaEditor.TOOLBAR_BUTTONS
              //
              // toolbar_buttons.push('|','liquid_variables')
              // return toolbar_buttons
            })(),
            'froalaEditor.initialized': (event) => {
              this.initialized(event)
            },
            'froalaEditor.contentChanged': (event, editor) => {
              this.on_content_changed(event, editor)
            },
            'froalaEditor.html.get': (event, editor, html) => {
              this.on_content_changed(event, editor, html)
            }
          }
        }
      }
    },
    methods: {
      initialized(event){
        console.log(`Froala initialized: ${event}`)
      },
      on_content_changed(event, editor, html) {
        console.log(`Content Changed: ${event}, ${editor}`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .froala {

  }
</style>
